// Exports helper functions for handling actions
import { createAction, ActionsUnion } from "../utils/utils";

// Enumerations of `Main` action types.
// Every action must have unique identifier in the application
export enum MainActionsEnum {
  SET_FETCHING_STATUS = "Set fetch status",
  SET_ACTIVE_SUBMENU = "Set active main submenu",
  SET_ACTIVE_USER = "Set active user",
  SET_EDIT_SIZE = "Set edit size",
  SET_PAGE_SIZE = "Set page size",
  SET_SHORTEN_TEXT_STATUS = "Set shorten text status",
  SET_LAST_EDITED_OBJECT_ID = "Set last edited object id"
}

// Creates collection of `Main` action functions
// Actions are functions to that will change the application state
// (Redux store). Actions are used in reducers.
// First parameter of the action is name from the enumeration above and the
// second value is payload = the data.
// Data is typed with typescript so no wrong data will be given.
export const mainActions = {
  setFetchingStatus: (status: string | undefined): Api.AnyItem =>
    createAction(MainActionsEnum.SET_FETCHING_STATUS, status),
  setActiveSubmenu: (menu: State.Submenu): Api.AnyItem =>
    createAction(MainActionsEnum.SET_ACTIVE_SUBMENU, menu),
  setActiveUser: (user: Api.User): Api.AnyItem =>
    createAction(MainActionsEnum.SET_ACTIVE_USER, user),
  setEditSize: (size: State.EditSize): Api.AnyItem =>
    createAction(MainActionsEnum.SET_EDIT_SIZE, size),
  setPageSize: (size: State.PageSize): Api.AnyItem =>
    createAction(MainActionsEnum.SET_PAGE_SIZE, size),
  setShortenTextStatus: (status: boolean): Api.AnyItem =>
    createAction(MainActionsEnum.SET_SHORTEN_TEXT_STATUS, status),
  setLastEditedObjectId: (
    id: number | string | undefined,
    parentid?: number | string | undefined
  ): Api.AnyItem => createAction(MainActionsEnum.SET_LAST_EDITED_OBJECT_ID, { id, parentid })
};

export type MainActions = ActionsUnion<typeof mainActions>;
